import React from 'react';
import { Nav, Navbar } from 'react-bootstrap';
import { NavLink, Link } from 'react-router-dom';
import LicenseNotification from '../../licenceNotification';
import AdminRoutes from '../AdminRoutes';
import { useAuthentication } from '../../authentiction';

const AdminShell: React.FC = () => {
  const { onLogout } = useAuthentication();

  return (
    <div>
      <Navbar collapseOnSelect expand="lg" bg="dark" variant="dark">
        <Navbar.Brand as={Link} to="/admin">
          Vis<sup>IT</sup> Administration
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="responsive-navbar-nav" />
        <Navbar.Collapse id="responsive-navbar-nav">
          <Nav className="ml-auto">
            <NavLink to="/admin" exact className="nav-link">
              Home
            </NavLink>
            <NavLink to="/admin/password" className="nav-link">
              Change Password
            </NavLink>
            <NavLink to="/admin/help" className="nav-link">
              Help
            </NavLink>
            <NavLink to="/" exact className="nav-link" onClick={onLogout}>
              Logout
            </NavLink>
          </Nav>
        </Navbar.Collapse>
      </Navbar>
      <LicenseNotification />
      <AdminRoutes />
    </div>
  );
};

export default AdminShell;
